"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tvl = exports.withdraw = exports.deposit = exports.setHashes = exports.initializeProtocol = exports.refreshLendingIx = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const sha256_uint8array_1 = require("sha256-uint8array");
const addressParser_1 = require("../addressParser");
const protocols_1 = require("../protocols");
const franciumKeysAll = (0, addressParser_1.addressParser)({
    group: "protocols",
    name: "francium",
});
const refreshLendingIx = (tokenInput) => {
    const franciumKeys = franciumKeysAll[tokenInput];
    const keys = [
        {
            pubkey: franciumKeys.marketInfoAccount,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: franciumKeys.lendingPoolInfoAccount,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
    ];
    return new anchor_1.web3.TransactionInstruction({
        keys,
        programId: franciumKeys.lendingProgram,
        data: Buffer.alloc(1, 12),
    });
};
exports.refreshLendingIx = refreshLendingIx;
function initializeProtocol(program) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const franciumKeys = franciumKeysAll[tokenInput];
        const vaultAccount = vaultKeys.vaultAccount;
        const vaultFranciumCollateralTokenAccount = yield (0, spl_token_1.getAssociatedTokenAddress)(franciumKeys.farmingPoolStakeTknMint, vaultAccount, true);
        vaultKeys.vaultFranciumCollateralTokenAccount =
            vaultFranciumCollateralTokenAccount;
        if (yield program.connection.getAccountInfo(vaultFranciumCollateralTokenAccount)) {
            console.log("francium accounts already initialized");
            return null;
        }
        else {
            const tx = new anchor_1.web3.Transaction();
            tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(program.user, vaultFranciumCollateralTokenAccount, vaultAccount, franciumKeys.farmingPoolStakeTknMint));
            return tx;
        }
    });
}
exports.initializeProtocol = initializeProtocol;
function setHashes(program) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const franciumKeys = franciumKeysAll[tokenInput];
        const depositData = new Uint8Array([
            ...vaultKeys.vaultFranciumCollateralTokenAccount.toBytes(),
            ...franciumKeys.lendingPoolInfoAccount.toBytes(),
            ...franciumKeys.lendingPoolTknAccount.toBytes(),
            ...franciumKeys.farmingPoolStakeTknMint.toBytes(),
            ...franciumKeys.marketInfoAccount.toBytes(),
            ...franciumKeys.lendingMarketAuthority.toBytes(),
        ]);
        const withdrawData = new Uint8Array([
            ...vaultKeys.vaultFranciumCollateralTokenAccount.toBytes(),
            ...franciumKeys.lendingPoolInfoAccount.toBytes(),
            ...franciumKeys.lendingPoolTknAccount.toBytes(),
            ...franciumKeys.farmingPoolStakeTknMint.toBytes(),
            ...franciumKeys.marketInfoAccount.toBytes(),
            ...franciumKeys.lendingMarketAuthority.toBytes(),
        ]);
        const tvlData = new Uint8Array([
            ...franciumKeys.lendingPoolInfoAccount.toBytes(),
            ...vaultKeys.vaultFranciumCollateralTokenAccount.toBytes(),
        ]);
        const HASH_LEN = 16;
        const hashes = [
            (0, sha256_uint8array_1.createHash)().update(depositData).digest().slice(0, HASH_LEN),
            (0, sha256_uint8array_1.createHash)().update(withdrawData).digest().slice(0, HASH_LEN),
            (0, sha256_uint8array_1.createHash)().update(tvlData).digest().slice(0, HASH_LEN),
        ];
        return program.methods
            .setHashes(protocols_1.Protocols.Francium, hashes)
            .accounts({
            userSigner: program.user,
            vaultAccount: vaultKeys.vaultAccount,
        })
            .transaction();
    });
}
exports.setHashes = setHashes;
function deposit(program, genericAcccounts) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const franciumKeys = franciumKeysAll[tokenInput];
        return program.methods
            .franciumDeposit()
            .accounts({
            genericAccs: genericAcccounts,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            franciumLendingProgramId: franciumKeys.lendingProgram,
            vaultFranciumCollateralTokenAccount: vaultKeys.vaultFranciumCollateralTokenAccount,
            franciumLendingPoolInfoAccount: franciumKeys.lendingPoolInfoAccount,
            franciumLendingPoolTokenAccount: franciumKeys.lendingPoolTknAccount,
            franciumFarmingPoolStakeTokenMint: franciumKeys.farmingPoolStakeTknMint,
            franciumMarketInfoAccount: franciumKeys.marketInfoAccount,
            franciumLendingMarketAuthority: franciumKeys.lendingMarketAuthority,
        })
            .preInstructions([(0, exports.refreshLendingIx)(tokenInput)])
            .transaction();
    });
}
exports.deposit = deposit;
function withdraw(program, genericAcccounts) {
    return __awaiter(this, void 0, void 0, function* () {
        return withdrawBuilder(program, genericAcccounts).transaction();
    });
}
exports.withdraw = withdraw;
function withdrawBuilder(program, genericAcccounts) {
    const tokenInput = program.tokenInput;
    const vaultKeys = program.vaultKeys[tokenInput];
    const franciumKeys = franciumKeysAll[tokenInput];
    return program.methods
        .franciumWithdraw()
        .accounts({
        genericAccs: genericAcccounts,
        franciumLendingProgramId: franciumKeys.lendingProgram,
        vaultFranciumCollateralTokenAccount: vaultKeys.vaultFranciumCollateralTokenAccount,
        franciumLendingPoolInfoAccount: franciumKeys.lendingPoolInfoAccount,
        franciumLendingPoolTokenAccount: franciumKeys.lendingPoolTknAccount,
        franciumFarmingPoolStakeTokenMint: franciumKeys.farmingPoolStakeTknMint,
        franciumMarketInfoAccount: franciumKeys.marketInfoAccount,
        franciumLendingMarketAuthority: franciumKeys.lendingMarketAuthority,
    })
        .preInstructions([(0, exports.refreshLendingIx)(tokenInput)]);
}
function tvl(program, genericAcccounts) {
    const tokenInput = program.tokenInput;
    const franciumKeys = franciumKeysAll[tokenInput];
    const vaultKeys = program.vaultKeys[tokenInput];
    return program.methods
        .franciumTvl()
        .accounts({
        genericAccs: genericAcccounts,
        lendingPool: franciumKeys.lendingPoolInfoAccount,
        vaultFranciumCollateralTokenAccount: vaultKeys.vaultFranciumCollateralTokenAccount,
    })
        .preInstructions([(0, exports.refreshLendingIx)(tokenInput)])
        .transaction();
}
exports.tvl = tvl;
//# sourceMappingURL=francium.js.map